import React, { PropTypes } from 'react';
import NewsEditForm from '../NewsEditForm';

class NewsEdit extends React.Component {
  static propTypes = {
    params: PropTypes.object.isRequired,
    loading: PropTypes.bool.isRequired,
    fetch: PropTypes.func.isRequired
  };

  state = {
    loading: true
  };

  componentWillMount() {
    let { id } = this.props.params;
    this.props.fetch(id);
  }

  componentWillReceiveProps(nextProps) {
    let { loading } = nextProps;
    this.setState({loading: this.state.loading && loading});
  }

  render() {
    let { loading } = this.state;

    return (
    <div>
      {!loading
        ? (<NewsEditForm title="Edit News"/>)
        : (<div>Loading</div>)
      }
    </div>

    );
  }
}

export default NewsEdit;




// WEBPACK FOOTER //
// ./src/components/News/NewsEdit/NewsEdit.jsx